import { createContext } from 'react';

import { BoardContextValue } from '@v2/pages/planboard/components/Board/web/types';

export const BoardContext = createContext<BoardContextValue | null>(null);
